import React, {useState} from 'react';
import InvitePic from "../../../assets/images/invite.jpg";
import {TiChevronLeft} from "react-icons/ti";
import {useNavigate} from "react-router-dom";
import Header from "../../../layouts/Header";
import {getUserInfo} from "../api/ProfileAPIs";
import {showError} from "../../../utils/toastHelper";
import Loading from "../../../layouts/Loading";

const InviteOthers = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [user , setUser] = React.useState([]);
    const config = window.APP_CONFIG;

    React.useEffect(() => {

        const fetchUserInfo = async () => {
            try {
                const data = await getUserInfo();
                setUser(data.data.user);
                setTimeout(() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }, 400)
            } catch (err) {
                showError(err);
            } finally {
                setLoading(false);

            }
        };
        fetchUserInfo();

    }, []);

    const share = () => {
        navigator.share({
            text: `برای ورود به سامانه    ${config.title}  لطفا از لینک زیر استفاده کنید`,
            url: `${config.shopping_app_settings.shopping_app_url}invite/${user.code}`
        })
    }

    if (loading) return <Loading />;

    return (
        <React.Fragment>
            <Header title=' دعوت از دیگران' hasBack={true} />
            <main className="container ">
                <div className="row px-3 ">

                    <div className="col-12 " >
                        <img src={InvitePic} alt={config.title} className="rounded mx-auto d-block mt-5 w-100" />
                    </div>
                    <div className="col-12 mb-5 px-4 pt-3 rtl text-justify border rounded text-small-3">
                        با معرفی
                        سامانه
                        &nbsp;

                        <strong>{config.title}</strong>
                        &nbsp;
                        به دیگران می توانید از سفارش هایی که توسط افراد معرفی شده توسط شما انجام می شود پورسانت دریافت کنید
                        <div className="row alert alert-success  text-center fw-bold mt-4"
                             onClick={()=>navigate('/reagents')}
                        >
                            <div className="col-7">
                                تعداد افراد معرفی شده :
                            </div>
                            <div className="col-4 text-start">
                                {user.reagent_count}
                                &nbsp;
                                نفر
                            </div>
                            <div className="col-1">
                                <TiChevronLeft className=' text-big-4' />
                            </div>
                        </div>

                    </div>

                    <div className="col-12 rtl text-end text-small-2 fw-bold">
                            لینک اختصاصی شما برای دعوت دیگران به سامانه
                        &nbsp;
                        {config.title  }:
                    </div>
                    <div className='col-12'>
                       <div className='alert alert-success bg-success text-white p-1 mt-4 text-center'
                       onClick={share}
                       >
                           {config.shopping_app_settings.shopping_app_url}invite/{user.reagent_code}
                       </div>
                    </div>
                </div>
            </main>

        </React.Fragment>
    );
};

export default InviteOthers;